import React from 'react'
import { Container } from 'reactstrap'

import ProcessStep from './ProcessStep'
import AwsServicesCard from '../AwsServicesCard'
import AwsSolutionsCard from '../AwsSolutionsCard'
import {
  SERVICES_ROUTE,
  MANAGED_ROUTE,
  WAF_ROUTE,
  MIGRATION_ROUTE,
} from '../../routes'

import review from './assets/review.svg'
import build from './assets/build.svg'
import modernization from './assets/moderization.svg'
import manage from './assets/manage.svg'
import lady from './assets/lady.svg'

import squaresLeft from '../../images/background/process-squares-left.svg'
import squaresRight from '../../images/background/process-squares-right.svg'

const STEPS = [
  {
    title: 'Design Services',
    className: 'blue',
    icon: review,
    items: [
      'Cloud Readiness',
      'Compliance Assessment',
      'Modernization Assessment',
      'Architecture Planning',
    ],
    link: SERVICES_ROUTE,
  },
  {
    title: 'Migrations',
    className: 'orange',
    icon: build,
    items: [
      'Environment Builds',
      'Automation Tools',
      'Migration & Launch',
      'Train & Document',
    ],
    link: MIGRATION_ROUTE,
  },
  {
    title: 'Optimizations',
    className: 'dark-blue',
    icon: modernization,
    items: ['Performance', 'Reliability', 'Cost', 'Operational Excellence'],
    link: WAF_ROUTE,
  },
  {
    title: 'Ongoing Management',
    className: 'green',
    icon: manage,
    items: [
      'Managed Cloud Support',
      'Cloud Architect Manager',
      'Security Services',
      'DevOps',
    ],
    link: MANAGED_ROUTE,
  },
]

const Process = ({ processRef }) => {
  return (
    <div className="Process" ref={processRef}>
      <img src={squaresLeft} alt="bg" className="Process__leftSquares" />
      <img src={squaresRight} alt="bg" className="Process__rightSquares" />

      <Container>
        <h2 className="Process__title">
          Customer Engagement Cycle
          <br />
        </h2>

        <div className="Process__lead">
          An AWS Premier Partner’s expertise at your fingertips. Crafting
          success through innovation, scalability, and training.
        </div>

        <div className="d-flex flex-column flex-md-row flex-md-wrap align-items-md-stretch">
          {STEPS.map((item, idx) => (
            <div
              className="w-100 w-md-50 w-lg-25 mb-3 pl-md-2 pr-md-2"
              key={idx}
            >
              <ProcessStep {...item} isOpenDefault={idx === 0} />
            </div>
          ))}
        </div>

        <div className="Process__lead pt-3 pt-md-4 pb-3 pb-md-4">
          Learn More How <b>Cloudnexa</b> Can Help You
        </div>

        <div className="d-flex flex-column flex-md-row flex-md-wrap align-items-md-stretch">
          <div className="w-100 w-md-50 w-lg-75 mb-3 pl-md-2 pr-md-2 mb-md-0">
            <AwsServicesCard />
          </div>

          <div className="w-100 w-md-50 w-lg-25 mb-3 pl-md-2 pr-md-2 mb-md-0">
            <AwsSolutionsCard />
          </div>

          <img src={lady} alt="lady" className="Process__lady" />
        </div>
      </Container>
    </div>
  )
}

export default Process
